import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Sections/Home";
import { Toaster } from 'react-hot-toast';

import "../src/style/boostrap.css";
import "../src/style/custom.css";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
